"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberCertified = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsPingAnRegister_1 = require("../../model/hsPingAnRegister");
var service_1 = require("../../../library/base/service");
var MemberCertified = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(MemberCertified, _super);
    function MemberCertified() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '恒生注册认证';
        _this.code = '105024';
        _this.desc = '恒生注册认证';
        _this.requestParams = new hsPingAnRegister_1.MemberCertifiedRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return MemberCertified;
}(service_1.BaseService));
exports.MemberCertified = MemberCertified;
//# sourceMappingURL=memberCertified.js.map